var sliders = {
	options: {
		accomodations_item_sliders_instances: [],
	},

	init: function () {
		var self = this;

		//Homepage / footer
		self.destinationsSlider();
		self.topAccomodationsSlider();
		self.newsSlider();

		//Accomodations archive
		self.accomodationsItemSlider(); //FIRED also IN accomodations.js
	},

	destinationsSlider: function () {
		if (!jQuery('.js-destinations-slider').length) {
			return false;
		}

		jQuery('.js-destinations-slider:not(.tns-slider)').each(function () {
			var slider = tns({
				container: this,
				items: 2,
				slideBy: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: true,
				nav: false,
				gutter: 24,
				responsive: {
					768: {
						'items': 3,
					},
					1024: {
						'items': 5.5,
					},
				}
			});
		});
	},

	topAccomodationsSlider: function () {
		if (!jQuery('.js-top-accomodations-slider').length) {
			return false;
		}

		jQuery('.js-top-accomodations-slider:not(.tns-slider)').each(function () {
			var slider = tns({
				container: this,
				items: 2,
				slideBy: 1,
				autoplay: false,
				loop: false,
				mouseDrag: true,
				controls: true,
				nav: false,
				gutter: 24,
				responsive: {
					768: {
						'items': 3,
					},
					1024: {
						'items': 4,
					},
				}
			});
		});
	},


	newsSlider: function () {
		if (!jQuery('.js-news-slider').length) {
			return false;
		}

		jQuery('.js-news-slider:not(.tns-slider)').each(function () {
			var slider = tns({
				container: this,
				items: 1,
				slideBy: 1,
				autoplay: false,
				gutter: 24,
				loop: false,
				mouseDrag: true,
				controls: true,
				nav: false,
				//gutter: 24,
				responsive: {
					768: {
						'items': 1,
					},
					1024: {
						'items': 3,
					},
				}
			});
		});
	},

	accomodationsItemSlider: function () {
		const self = this;

		//Before init destroy current created
		self.options.accomodations_item_sliders_instances.forEach(slider => {
			slider.destroy();
		});

		self.options.accomodations_item_sliders_instances = [];

		jQuery('#js-accomodations-list li.show .js-accomodations-item-slider:not(.tns-slider)').each(function () {
			if (jQuery(this).children().length <= 1) return true; //skip current iteration if only 1 image is present

			var slider = tns({
				container: this,
				items: 1,
				slideBy: 1,
				autoplay: false,
				gutter: 0,
				loop: true,
				mouseDrag: true,
				controls: true,
				controlsContainer: this.parentElement.querySelector('.js-accomodations-item-slider-controls'),
				nav: true,
				navContainer: this.parentElement.querySelector('.js-accomodations-item-slider-nav'),
			});

			self.options.accomodations_item_sliders_instances.push(slider);
		});

		jQuery('.js-accomodations-item-slider-controls').children().off('click.btkcNameSpace').on("click.btkcNameSpace", function (event) {
			event.preventDefault(); //disallow redirect <a href...>
		});

		jQuery('.js-accomodations-item-slider-nav').children().off('click.btkcNameSpace').on("click.btkcNameSpace", function (event) {
			event.preventDefault(); //disallow redirect <a href...>
		});
	}
};

export { sliders };
